import React from 'react';
import { Code, ArrowLeft } from 'lucide-react';
import { Button } from '../../ui';

interface HeaderProps {
  onBack: () => void;
}

export function Header({ onBack }: HeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-navy-700/50 bg-gradient-to-r from-navy-800 to-navy-700/30">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="p-1.5 bg-purple-500/15 rounded-lg ring-1 ring-purple-500/20 flex-shrink-0">
          <Code className="w-4 h-4 text-purple-400" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-bold text-white truncate">Debugger CorelDraw</h3>
          <p className="text-[11px] text-gray-400 truncate">Painel Administrativo</p>
        </div>
      </div>
      <Button
        variant="ghost"
        size="xs"
        onClick={onBack}
        icon={ArrowLeft}
        title="Voltar ao menu (ESC)"
        className="flex-shrink-0 ml-3 text-gray-300 hover:text-white"
      >
        <span className="hidden sm:inline text-xs">Voltar</span>
      </Button>
    </div>
  );
}


